// import Demo from './Demo-ReactMotion';
// import Demo from './Demo-UIPack';
import Demo from './Demo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions
import { setLoading } from '../../redux/loading/actions';

// Redux
const mapStateToProps = (state) => {
  return {
    campaigns: state.campaigns,
    isLoading: state.loading.isLoading,
    // percent: state.loading.percent,
    // answers: state.answers,
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setLoading
  }, dispatch);
}

const ConnectedDemo = connect(
  mapStateToProps,
  mapDispatchToProps
)(Demo);

export default ConnectedDemo;



// WEBPACK FOOTER //
// ./src/pages/Demo/index.js